import { useState } from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import { Popover, Space, Row, Col, Button } from 'antd';
import styles from './DeleteDbParametersPopover.module.less';

interface UpdateDbParametersPopoverProps {
    handleOk: () => void;
    testId?: string;
}

const UpdateDbParametersPopover = ({
    handleOk,
    testId = 'UpdateDbParametersPopover',
}: UpdateDbParametersPopoverProps) => {
    const [openPopover, setOpenPopover] = useState(false);

    const handleSubmit = () => {
        setOpenPopover(false);
        handleOk();
    };

    return (
        <Popover
            data-testid={testId}
            open={openPopover}
            placement="left"
            content={
                <>
                    <Row justify={'end'} className={styles.PopoverContentRow}>
                        <Col span={2}>
                            <InfoCircleFilled
                                className={styles.ExclamationCircleFilledColor}
                            />
                        </Col>
                        <Col span={22}>
                            <div>Are you sure?</div>
                            <div>
                                The datastore configuration will be applied to
                                all associated data stores.
                            </div>
                        </Col>
                    </Row>

                    <Row justify={'end'} className={styles.PopoverActionsRow}>
                        <Space>
                            <Button
                                type="primary"
                                onClick={() => handleSubmit()}
                            >
                                Yes
                            </Button>
                            <Button onClick={() => setOpenPopover(false)}>
                                No
                            </Button>
                        </Space>
                    </Row>
                </>
            }
            trigger="click"
            onOpenChange={setOpenPopover}
        >
            <Button type="primary" onClick={() => setOpenPopover(!openPopover)}>
                Update
            </Button>
        </Popover>
    );
};

export default UpdateDbParametersPopover;
